const GET_CURRENCY = "GET_CURRENCY";
const GET_CURRENCY_SUCCESS = "GET_CURRENCY_SUCCESS";
const GET_CURRENCY_FAIL = "GET_CURRENCY_FAIL";

const BASE_ENDPOINT = "/MasterData";
const initialValues = {
  loading: false,
  hasError: false,
  data:[]
};

const currencies = (state = initialValues, action) => {
  switch (action.type) {
    case GET_CURRENCY: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_CURRENCY_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      };
    }

    case GET_CURRENCY_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }
   
    default: {
      return state;
    }
  }
};

export const getCurrencies = () => {
  return {
    type: GET_CURRENCY,
    payload: {
      request: {
        method: "GET",
        url: BASE_ENDPOINT + "/Currency",
      },
    },
  };
};

export default currencies;
